import React from 'react';
import './SmallCardInfo.css';

type SmallCardInfoProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> 
& {
  title: string,
  firstDcp: string,
  secondDcp: string,
  img:string,

  className?: string
}

const SmallCardInfo: React.FC<SmallCardInfoProps> = ({ 
  title, firstDcp, secondDcp, img, 
  ...props
}) => {
  return (
    <div {...props} className={` p-5 mx-5 my-5 ${props.className ? props.className : ''}`}>
      <div className="flex items-center justify-center">
        <div className='rounded-full h-20 w-20 bgColor flex items-center justify-center'>
          <img className='svgFormat' src={img} alt=''></img>
        </div>
      </div>
      <div className="text-center">
        <div className="text-2xl font-bold pt-4">{title}</div>
        <p className="text-gray-600 pt-1">{firstDcp}</p>
        <p className="text-gray-500">{secondDcp}</p>
      </div>
    </div>
  )
}

export default SmallCardInfo;